import { Routes } from '@angular/router';
import { inject } from '@angular/core';
import { ActiveTripGuard } from './core/guards/active-trip.guard';
import { startupRedirectGuard } from './core/guards/startup-redirect.guard';

export const routes: Routes = [
  {
    path: 'home',
    loadComponent: () => import('./home/home.page').then((m) => m.HomePage),
  },
  {
    // The guard decides /home vs /login from the token and always returns a
    // UrlTree, so this component is never actually instantiated. It is named
    // anyway because recognition runs before guards do: a componentless route
    // with nothing to match the empty remaining segment fails to recognise,
    // and the guard would never get to run.
    path: '',
    pathMatch: 'full',
    canActivate: [startupRedirectGuard],
    loadComponent: () => import('./login/login.page').then(m => m.LoginPage),
  },
  {
    path: 'login',
    loadComponent: () => import('./login/login.page').then(m => m.LoginPage)
  },
  {
    path: 'active-trip/:id',
    loadComponent: () => import('./active-trip/active-trip.component').then(m => m.ActiveTripComponent),
    canDeactivate: [(component: any) => inject(ActiveTripGuard).canDeactivate(component)]
  },
  {
    path: 'self-dispatch',
    loadComponent: () => import('./self-dispatch/self-dispatch.page').then(m => m.SelfDispatchPage)
  },
  {
    path: 'profile',
    loadComponent: () => import('./profile/profile.page').then(m => m.ProfilePage)
  },
  {
    path: 'my-vehicles',
    loadComponent: () => import('./my-vehicles/my-vehicles.page').then(m => m.MyVehiclesPage)
  },
  {
    path: 'justify-trip/:tripId',
    loadComponent: () => import('./justify-trip/justify-trip.page').then(m => m.JustifyTripPage)
  },
  {
    path: '**',
    redirectTo: 'login'
  }
];
